function NotificationIcon() {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.18336 18L8.58336 18.6857C10.3834 21.7714 13.9834 21.7714 15.7834 18.6857L16.1834 18M4.36619 15.5496L4.46954 15.7627C5.13331 17.1311 6.52054 18 8.04144 18H16.2623C17.5656 18 18.7785 17.3342 19.4783 16.2347C20.4661 14.6826 20.2045 12.6465 18.8564 11.3945L18.8125 11.3538C17.8972 10.5038 17.4466 9.26543 17.6015 8.02598L17.6662 7.50905C18.0318 4.58379 15.7509 2 12.8029 2H11.0999C8.15552 2 5.87737 4.58064 6.24258 7.50234L6.32194 8.13719C6.46808 9.30631 6.04102 10.4741 5.17514 11.2731C3.99242 12.3645 3.66383 14.1016 4.36619 15.5496Z"
          stroke="#2D264B"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  }


  export {

    NotificationIcon,
   
  };
  